<template>
  <el-popover placement="bottom" :width="width" trigger="click" @show="show">
    <el-input ref="input" slot="reference" :value="keyword" clearable :size="size" :placeholder="placeholder" :style="style" @focus="focus" @clear="clear">
      <el-button slot="append" icon="el-icon-search" @click="search" />
    </el-input>

    <template>
      <el-input v-model="textarea" ref="textarea" type="textarea" resize="none" :rows="6" :placeholder="placeholder" />
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    width: {
      type: Number,
      required: false,
      default: 298
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Searching for ID'
    }
  },
  data() {
    return {
      keyword: undefined,
      textarea: undefined
    }
  },
  computed: {
    style() {
      return {
        width: `${this.width}px`
      }
    }
  },
  watch: {
    textarea(value) {
      if (value) {
        let result = value.split(/[\r\n]+/).filter((item) => item !== '')
        this.keyword = result.join(',')
      }
    }
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },

    focus() {
      this.$refs.input.blur()
    },

    clear() {
      this.keyword = undefined
      this.textarea = undefined
      this.$emit('clear')
    },

    search() {
      this.$emit('search', this.keyword)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-popover {
  border-radius: 12px;
}

.el-input {
  /deep/.el-input__inner {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  /deep/.el-input-group__append {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    background-color: rgba(153, 196, 28, 0.2);
  }
}
</style>
